export default {
  listState: state => state.list,
  listOptionsState: state => state.listOptions
}
